import Tile from '@commons/components/Tile/Tile';

import type { PageNodeProps } from '.';

/**
 * Page node component for the Tile display type.
 */

const PageNodeTile = ({ image, title, alias }: PageNodeProps) => (
  <Tile href={alias} title={title} image={image} />
);

export default PageNodeTile;
